import { useContext } from 'react';
import { StepperContext, StepperContextProps } from './StepperProvider';

export const useStepper = (): StepperContextProps => {
  const context = useContext(StepperContext);
  if (context === undefined) {
    throw new Error('useStepper must be used within a StepperProvider');
  }
  return context;
};
